import {
  Address,
  AddressFromServer,
  CityAutoComplete,
  CompanyAddress,
  Coupon,
  CuisineTypes,
  DishAssignedUsers,
  LinkMoneycardToUserRequest,
  MenuCategories,
  Order,
  OrderData,
  Payment,
  ReOrderResponse,
  RestaurantAbout,
  RestaurantCoupons,
  RestaurantGroupRestaurants,
  RestaurantReviews,
  RestaurantList,
  StreetAutoComplete,
  Transaction,
  User,
  UserOrdersHistory,
  UserOrdersHistoryForRestaurant,
  LoginProviderResponse,
  SearchedDishList,
  OrderSubmitError,
  TenBisAddressLocationFromServer,
  InsertTransferDebitResponse,
  UserVouchers,
  MoneycardOtlRuleManagement,
  GuestCard,
  GuestCardRule,
  GuestCardHolder,
  CreateGuestCardRuleParams,
  UpdateGuestCardEnabledRuleParams,
} from '~/shared/store/models';
import {SignUpCredentials} from '~/shared/store/storeModules/restrictedSharedActions';
import {GetUserAuthenticationDataResponse} from '~/shared/store/models/GetUserAuthenticationDataResponse';
import {
  SetTransferDebitRequestStatusResponse,
  UpsertOverTheLimitRuleParams,
  GetActivationTokenAndSendActivationCodeToUserArgs,
  RemovePayPalUserTokenPayload,
} from '~/shared/services/apiService/models';

import {ApiError} from '../apiErrorService';

import {ApiResponse} from './index';

const apiServiceConfig: ApiServiceConfig = {
  getUserAuthenticationDataAndSendAuthenticationCodeToUser: {
    url: 'GetUserAuthenticationDataAndSendAuthenticationCodeToUser_V2',
    method: 'post',
  },
  getUserV2: {
    url: 'GetUserV2',
    method: 'post',
    noGetTimeStampParam: true,
    useShoppingCartGuid: true,
  },
  getUser: {
    url: 'GetUser',
    method: 'post',
    noGetTimeStampParam: true,
    useShoppingCartGuid: true,
  },
  googleLogin: {
    url: 'GoogleLogin',
    method: 'post',
    useShoppingCartGuid: true,
  },
  govLogin: {
    url: 'SignInCompanyUserByIdentifier',
    method: 'post',
  },

  signOut: {url: 'SignOut', method: 'post'},

  // This function expects hebrew variables so you should probably use ~/shared/services/getTenBisAddressLocation
  getTenBisAddressLocationHebrewOnly: {
    url: 'GetTenBisAddressLocation',
    method: 'get',
    noGetTimeStampParam: true,
    useShoppingCartGuid: true,
  },

  insertPayPalUserToken: {
    url: 'InsertPayPalUserToken',
    method: 'post',
    useShoppingCartGuid: true,
  },
  removePayPalUserToken: {
    url: 'RemovePayPalUserToken',
    method: 'post',
  },
  generatePayPalClientToken: {
    url: 'GeneratePayPalClientToken',
    method: 'get',
    noGetTimeStampParam: true,
  },

  getInsertNewCreditCardIframeUrl: {
    url: 'GetInsertNewCreditCardIframeUrl',
    method: 'get',
    useShoppingCartGuid: true,
  },
  getInsertNewCreditCardIframeUrlV2: {
    url: 'GetInsertNewCreditCardIframeUrl_V2',
    method: 'get',
    useShoppingCartGuid: true,
  },

  userTransactionsReport: {
    url: 'UserTransactionsReport',
    method: 'post',
  },
  getBarcodeOrder: {url: 'GetOrderBarcode', method: 'get'},
  setTransferDebitRequestStatus: {url: 'SetTransferDebitRequestStatus', method: 'post'},
  insertTransferDebitRequest: {url: 'InsertTransferDebitRequest', method: 'post'},

  registerUser: {url: 'RegisterUser', method: 'post', useShoppingCartGuid: true},
  registerCompanyUser: {url: 'RegisterCompanyUser', method: 'post', useShoppingCartGuid: true},
  updateUserDetails: {
    url: 'UpdateUserDetails',
    method: 'post',
    useShoppingCartGuid: true,
    convertParams: false,
  },
  updateUserPassword: {
    url: 'UpdateUserPassword',
    method: 'post',
    useShoppingCartGuid: false,
    convertParams: false,
  },
  activateMoneycard: {url: 'ActivateMoneycard', method: 'post'},

  getActivationTokenAndSendActivationCodeToUser: {
    url: 'GetActivationTokenAndSendActivationCodeToUser',
    method: 'get',
  },

  resetPassword: {url: 'ResetPassword', method: 'post'},

  cityNameAutoComplete: {url: 'CityNameAutoComplete', method: 'get'},
  streetNameAutoComplete: {
    url: 'StreetNameAutoComplete',
    method: 'get',
  },
  isEmailFree: {url: 'IsEmailFree', method: 'get'},

  getRestaurantsByGroupId: {
    url: 'getRestaurantsByGroupId',
    method: 'get',
  },

  getRestaurantDescriptionAndFeatures: {
    url: 'GetRestaurantDescriptionAndFeatures',
    method: 'get',
    useShoppingCartGuid: false,
  },

  getRestaurantReviews: {
    url: 'GetRestaurantReviews',
    method: 'get',
    useShoppingCartGuid: false,
  },
  validateInsertReview: {
    url: 'ValidateInsertReview',
    method: 'post',
    useShoppingCartGuid: false,
  },
  upsertRestaurantReview: {
    url: 'UpsertRestaurantReview',
    method: 'post',
    useShoppingCartGuid: false,
  },
  getLastTransactionWithoutReview: {
    url: 'GetLastTransactionWithoutReview',
    method: 'post',
  },
  searchRestaurants: {
    url: 'searchRestaurants_V2',
    method: 'get',
    useShoppingCartGuid: true,
    sendIsMobileDevice: true,
  },
  getRestaurantMenu: {url: 'GetRestaurantMenu', method: 'get', useShoppingCartGuid: true},
  getOrderData: {
    url: 'getOrderData',
    method: 'get',
    useShoppingCartGuid: true,
  },

  setRestaurantInOrder: {
    url: 'SetRestaurantInOrder',
    method: 'post',
    useShoppingCartGuid: true,
    sendIsMobileDevice: true,
  },
  createLinkMoneycardToUserRequest: {
    url: 'CreateLinkMoneycardToUserRequest',
    method: 'post',
  },
  getLinkMoneycardToUserRequests: {url: 'GetLinkMoneycardToUserRequests', method: 'post'},

  setDeliveryMethodInOrder: {
    url: 'SetDeliveryMethodInOrder',
    method: 'post',
    useShoppingCartGuid: true,
  },
  setUserInOrder: {url: 'SetUserInOrder', method: 'post', useShoppingCartGuid: true},
  setAddressInOrder: {url: 'SetAddressInOrder', method: 'post', useShoppingCartGuid: true},
  setTipInOrder: {
    url: 'SetTipInOrder',
    method: 'post',
    useShoppingCartGuid: true,
  },

  // chooses the max value from all set coupons, including the currently set coupon in order
  // uf a better than a menually set coupon is chosen, it disappears from the order, because it's only stored there.
  chooseAndSetBestDiscountCouponValueInOrder: {
    method: 'post',
    url: 'ChooseAndSetBestDiscountCouponValueInOrder',
    useShoppingCartGuid: true,
  },
  // when set, the coupon stays in order until replaced with this call or by ChooseAndSetBestDiscountCouponValueInOrder
  // manually set coupons, that are per session, are stored only in the shopping cart itself
  // coupons per users will be kept in available coupons
  setCouponInOrder: {url: 'SetCouponInOrder', method: 'post', useShoppingCartGuid: true},
  // full coupons info for a restaurant to be used in the coupons modal/page UI
  getRestaurantDiscounts: {url: 'GetRestaurantDiscountsData', method: 'get'},
  // a statefull api based on the last restaurant set in order.
  // returns the relevant coupons for the user including the current restaurant's coupon,
  // and coupons appended to the user from the user details page.
  // manually added coupons from setCouponInOrder will be returned from this function
  // if they are per user and not per session
  getAvailableCouponsForOrder: {
    url: 'GetAvailableCouponsForOrder',
    method: 'get',
    useShoppingCartGuid: true,
  },

  submitOrder: {
    url: 'SubmitOrder',
    method: 'post',
    useShoppingCartGuid: true,
    sendIsMobileDevice: true,
    timeout: 60000,
  },

  getAddressDetails: {url: 'GetAddressViewModel', method: 'get'},

  getDishAssignedUsers: {
    url: 'GetDishAssignedUsers',
    method: 'get',
    useShoppingCartGuid: true,
  },

  getCompanyAddresses: {url: 'GetCompanyAddresses', method: 'get'},
  appendCompanyAddressToUser: {url: 'AppendCompanyAddressToUser', method: 'post'},

  getUserAddresses: {url: 'GetUserAddresses', method: 'post'},
  updateAddress: {url: 'UpdateAddress_V2', method: 'post'},
  insertAddress: {url: 'InsertAddress_V2', method: 'post'},
  removeAddress: {url: 'RemoveAddress', method: 'post'},

  getAvailablePayments: {
    url: 'GetPayments',
    method: 'get',
    useShoppingCartGuid: true,
  },
  setPaymentsInOrder: {
    url: 'SetPaymentsInOrder',
    method: 'post',
    useShoppingCartGuid: true,
  },

  getLinkMoneycardToUserRequestForLandingPage: {
    url: 'GetLinkMoneycardToUserRequestForLandingPage',
    method: 'post',
  },

  setLinkMoneycardToUserRequestStatus: {
    url: 'SetLinkMoneycardToUserRequestStatus',
    method: 'post',
  },

  setDishListInShoppingCart: {
    url: 'SetDishListInShoppingCart',
    method: 'post',
    useShoppingCartGuid: true,
  },

  setFutureTimeInOrder: {
    url: 'SetFutureTimeInOrder',
    method: 'post',
    useShoppingCartGuid: true,
  },

  sendShareOrderLink: {
    url: 'SendShareOrderLink',
    method: 'post',
    useShoppingCartGuid: false,
  },

  getOrdersHistory: {
    url: 'GetUserOrdersHistory',
    method: 'get',
    useShoppingCartGuid: false,
  },

  reorder: {url: 'ReOrder', method: 'get', useShoppingCartGuid: true},

  setPermitCodeInOrder: {
    url: 'SetPermitCodeInOrder',
    method: 'post',
    useShoppingCartGuid: true,
  },

  getSingleOrderViewInfo: {
    method: 'get',
    url: 'GetSingleOrderViewInfo',
    urlPrefix: 'Account/',
  },

  getMoneycardOtlRuleManagement: {url: 'GetMoneycardOtlRuleManagement', method: 'post'},
  UpsertOverTheLimitRule: {url: 'UpsertOverTheLimitRule', method: 'post'},
  searchDishesByCulture: {url: 'SearchDishes', method: 'post'},

  getReOrderMenuItems: {
    url: 'GetReOrderMenuItems',
    method: 'get',
    useShoppingCartGuid: true,
  },
  getUserOrdersHistoryForRestaurant: {
    url: 'GetUserOrdersHistoryForRestaurant',
    method: 'get',
  },

  getRestaurantCuisineTypes: {url: 'GetRestaurantCuisineTypes', method: 'get'},

  // Guest Cards (CompAdmin). Unlike the other NextApi endpoints, these return their payload
  // directly (a raw array or boolean) instead of the standard {success, data, errors} envelope,
  // so they are flagged `isRawResponse` to bypass the envelope check in the response interceptor.
  getGuestCardsData: {url: 'GetGuestCardsData', method: 'get', isRawResponse: true},
  getGuestCardRules: {url: 'GetGuestCardRules', method: 'get', isRawResponse: true},
  getCompanyCardHolders: {url: 'GetCompanyCardHolders', method: 'get', isRawResponse: true},
  createNewGuestCardRule: {url: 'CreateNewGuestCardRule', method: 'post', isRawResponse: true},
  updateGuestCardEnabledRule: {url: 'UpdateGuestCardEnabledRule', method: 'post', isRawResponse: true},
};

export default apiServiceConfig;

type ApiServiceConfig = {
  [FunctionName in keyof ConfigFunctions]: {
    [Param in ConfigFunctions[FunctionName]['Params'][number]]: ApiServiceConfigParams[Param];
  };
};

export type ApiServiceConfigFunctions = {
  [FunctionName in keyof ConfigFunctions]: ConfigFunctions[FunctionName]['Raw'] extends true
    ? ApiServiceRawFunction<
        ConfigFunctions[FunctionName]['ReturnType'],
        ConfigFunctions[FunctionName]['Args']
      >
    : ApiServiceFunction<
        ConfigFunctions[FunctionName]['ReturnType'],
        ConfigFunctions[FunctionName]['ErrorType'],
        ConfigFunctions[FunctionName]['Args']
      >;
};

type GenericConfigFunction<
  P extends Array<keyof Omit<ApiServiceConfigParams, 'url' | 'method'>> = [],
  R = unknown,
  E extends ApiError = ApiError,
  Args extends Record<string, any> | undefined = undefined,
  Raw extends boolean = false,
> = {
  Params: [...ConfigFunctionParamsBase, ...P];
  ReturnType: R;
  ErrorType: E;
  Args: Args extends Record<string, any> ? Args : undefined;
  Raw: Raw;
};

export interface ApiServiceConfigParams {
  url: string;
  method: 'post' | 'get' | 'head';
  noGetTimeStampParam?: boolean;
  useShoppingCartGuid?: boolean;
  urlPrefix?: string;
  convertParams?: boolean;
  timeout?: number;
  sendIsMobileDevice?: boolean;
  // When true, the endpoint returns its payload directly (not wrapped in the standard
  // {success, data, errors} envelope), so the response interceptor skips the envelope check
  // and the generated function resolves to the raw payload instead of an ApiResponse.
  isRawResponse?: boolean;
}

export interface ApiServiceFunctionWithArgs<Payload, Error extends ApiError = ApiError, Params extends Record<string, any> = Record<string, any>> {
  (params: Params, userPayload?: {useDefaultLocale?: boolean}): Promise<
    ApiResponse<Payload>
  >;
  (params: Params, userPayload?: {useDefaultLocale?: boolean}): Promise<
    ApiResponse<Payload | Error>
  >;
}

export interface ApiServiceFunctionWithoutArgs<Payload, Error extends ApiError = ApiError> {
  (params?: Record<string, any>, userPayload?: {useDefaultLocale?: boolean}): Promise<
    ApiResponse<Payload>
  >;
  (params?: Record<string, any>, userPayload?: {useDefaultLocale?: boolean}): Promise<
    ApiResponse<Payload | Error>
  >;
}

export type ApiServiceFunction<
  Payload,
  Error extends ApiError = ApiError,
  Params extends Record<string, any> | undefined = undefined
> = Params extends Record<string, any> ?
  ApiServiceFunctionWithArgs<Payload, Error, Params> :
  ApiServiceFunctionWithoutArgs<Payload, Error>;

// Raw endpoints (isRawResponse: true) resolve to the payload directly, not an ApiResponse envelope.
export interface ApiServiceRawFunctionWithArgs<Payload, Params extends Record<string, any> = Record<string, any>> {
  (params: Params, userPayload?: {useDefaultLocale?: boolean}): Promise<Payload>;
}

export interface ApiServiceRawFunctionWithoutArgs<Payload> {
  (params?: Record<string, any>, userPayload?: {useDefaultLocale?: boolean}): Promise<Payload>;
}

export type ApiServiceRawFunction<
  Payload,
  Params extends Record<string, any> | undefined = undefined
> = Params extends Record<string, any> ?
  ApiServiceRawFunctionWithArgs<Payload, Params> :
  ApiServiceRawFunctionWithoutArgs<Payload>;

type ConfigFunctionParamsBase = ['url', 'method'];

interface ConfigFunctions {
  getUserAuthenticationDataAndSendAuthenticationCodeToUser: GenericConfigFunction<[], GetUserAuthenticationDataResponse>;
  getUserV2: GenericConfigFunction<['noGetTimeStampParam', 'useShoppingCartGuid'], User>;
  getUser: GenericConfigFunction<['noGetTimeStampParam', 'useShoppingCartGuid'], User>;
  googleLogin: GenericConfigFunction<['useShoppingCartGuid'], LoginProviderResponse>;
  govLogin: GenericConfigFunction<[], User>;
  signOut: GenericConfigFunction;
  getTenBisAddressLocationHebrewOnly: GenericConfigFunction<
    ['noGetTimeStampParam', 'useShoppingCartGuid'],
    TenBisAddressLocationFromServer
  >;
  insertPayPalUserToken: GenericConfigFunction<['useShoppingCartGuid']>;
  removePayPalUserToken: GenericConfigFunction<[], boolean, ApiError, RemovePayPalUserTokenPayload>;
  generatePayPalClientToken: GenericConfigFunction<['noGetTimeStampParam'], string>;
  getInsertNewCreditCardIframeUrl: GenericConfigFunction<['useShoppingCartGuid']>;
  getInsertNewCreditCardIframeUrlV2: GenericConfigFunction<['useShoppingCartGuid']>;
  userTransactionsReport: GenericConfigFunction;
  getBarcodeOrder: GenericConfigFunction<[], UserVouchers>;
  setTransferDebitRequestStatus: GenericConfigFunction<[], SetTransferDebitRequestStatusResponse>;
  insertTransferDebitRequest: GenericConfigFunction<[], InsertTransferDebitResponse>;
  registerUser: GenericConfigFunction<['useShoppingCartGuid'], User, ApiError, SignUpCredentials>;
  registerCompanyUser: GenericConfigFunction<['useShoppingCartGuid'], User, ApiError, SignUpCredentials>;
  updateUserDetails: GenericConfigFunction<['useShoppingCartGuid', 'convertParams']>;
  updateUserPassword: GenericConfigFunction<['useShoppingCartGuid', 'convertParams']>;
  activateMoneycard: GenericConfigFunction;
  getActivationTokenAndSendActivationCodeToUser: GenericConfigFunction<[], string, ApiError, GetActivationTokenAndSendActivationCodeToUserArgs>;
  resetPassword: GenericConfigFunction<[], boolean>;
  cityNameAutoComplete: GenericConfigFunction<[], CityAutoComplete[]>;
  streetNameAutoComplete: GenericConfigFunction<[], StreetAutoComplete[]>;
  isEmailFree: GenericConfigFunction<[]>;
  getRestaurantsByGroupId: GenericConfigFunction<[], RestaurantGroupRestaurants>;
  getRestaurantDescriptionAndFeatures: GenericConfigFunction<['useShoppingCartGuid'], RestaurantAbout>;
  getRestaurantReviews: GenericConfigFunction<['useShoppingCartGuid'], RestaurantReviews>;
  validateInsertReview: GenericConfigFunction<['useShoppingCartGuid'], boolean>;
  upsertRestaurantReview: GenericConfigFunction<['useShoppingCartGuid'], number>;
  getLastTransactionWithoutReview: GenericConfigFunction<[], Transaction>;
  searchRestaurants: GenericConfigFunction<['useShoppingCartGuid', 'sendIsMobileDevice'], RestaurantList>;
  getRestaurantMenu: GenericConfigFunction<['useShoppingCartGuid'], MenuCategories>;
  getOrderData: GenericConfigFunction<['useShoppingCartGuid'], OrderData>;
  setRestaurantInOrder: GenericConfigFunction<['useShoppingCartGuid', 'sendIsMobileDevice'], OrderData>;
  createLinkMoneycardToUserRequest: GenericConfigFunction;
  getLinkMoneycardToUserRequests: GenericConfigFunction<[], LinkMoneycardToUserRequest[]>;
  setDeliveryMethodInOrder: GenericConfigFunction<['useShoppingCartGuid'], OrderData>;
  setUserInOrder: GenericConfigFunction<['useShoppingCartGuid'], OrderData>;
  setAddressInOrder: GenericConfigFunction<['useShoppingCartGuid'], OrderData>;
  setTipInOrder: GenericConfigFunction<['useShoppingCartGuid'], OrderData>;
  chooseAndSetBestDiscountCouponValueInOrder: GenericConfigFunction<['useShoppingCartGuid'], OrderData>;
  setCouponInOrder: GenericConfigFunction<['useShoppingCartGuid'], OrderData>;
  getRestaurantDiscounts: GenericConfigFunction<[], RestaurantCoupons>;
  getAvailableCouponsForOrder: GenericConfigFunction<['useShoppingCartGuid'], Coupon[]>;
  submitOrder: GenericConfigFunction<['useShoppingCartGuid', 'sendIsMobileDevice', 'timeout'], Order, OrderSubmitError>;
  getAddressDetails: GenericConfigFunction<[], Address>;
  getDishAssignedUsers: GenericConfigFunction<['useShoppingCartGuid'], DishAssignedUsers>;
  getCompanyAddresses: GenericConfigFunction<[], CompanyAddress[]>;
  appendCompanyAddressToUser: GenericConfigFunction;
  getUserAddresses: GenericConfigFunction<[], AddressFromServer[]>;
  updateAddress: GenericConfigFunction<[], number>;
  insertAddress: GenericConfigFunction<[], number>;
  removeAddress: GenericConfigFunction<[], number>;
  getAvailablePayments: GenericConfigFunction<['useShoppingCartGuid'], Payment[]>;
  setPaymentsInOrder: GenericConfigFunction<['useShoppingCartGuid'], OrderData>;
  getLinkMoneycardToUserRequestForLandingPage: GenericConfigFunction;
  setLinkMoneycardToUserRequestStatus: GenericConfigFunction<[], LinkMoneycardToUserRequest>;
  setDishListInShoppingCart: GenericConfigFunction<['useShoppingCartGuid'], OrderData>;
  setFutureTimeInOrder: GenericConfigFunction<['useShoppingCartGuid'], OrderData>;
  sendShareOrderLink: GenericConfigFunction<['useShoppingCartGuid'], boolean>;
  getOrdersHistory: GenericConfigFunction<['useShoppingCartGuid'], UserOrdersHistory>;
  reorder: GenericConfigFunction<['useShoppingCartGuid'], ReOrderResponse>;
  setPermitCodeInOrder: GenericConfigFunction<['useShoppingCartGuid'], OrderData>;
  getSingleOrderViewInfo: GenericConfigFunction<['urlPrefix']>;
  getMoneycardOtlRuleManagement: GenericConfigFunction<[], MoneycardOtlRuleManagement>;
  UpsertOverTheLimitRule: GenericConfigFunction<[], MoneycardOtlRuleManagement['otlRuleData'], ApiError, UpsertOverTheLimitRuleParams>;
  searchDishesByCulture: GenericConfigFunction<[], SearchedDishList>;
  getReOrderMenuItems: GenericConfigFunction<['useShoppingCartGuid']>;
  getUserOrdersHistoryForRestaurant: GenericConfigFunction<[], UserOrdersHistoryForRestaurant>;
  getRestaurantCuisineTypes: GenericConfigFunction<[], CuisineTypes>;
  getGuestCardsData: GenericConfigFunction<['isRawResponse'], GuestCard[], ApiError, undefined, true>;
  getGuestCardRules: GenericConfigFunction<['isRawResponse'], GuestCardRule[], ApiError, {encryptedCardId: string}, true>;
  getCompanyCardHolders: GenericConfigFunction<['isRawResponse'], GuestCardHolder[], ApiError, undefined, true>;
  createNewGuestCardRule: GenericConfigFunction<['isRawResponse'], boolean, ApiError, CreateGuestCardRuleParams, true>;
  updateGuestCardEnabledRule: GenericConfigFunction<['isRawResponse'], boolean, ApiError, UpdateGuestCardEnabledRuleParams, true>;
}
